
import React from 'react';

import './loading.scss';

export default function Loading() {
    return (
        <div className="page-loading">
            <div className="sprite-frame"></div>
        </div>
    );
}

